const authorPosts = async function( $block ) {
	const { Swiper } = await import( "swiper" );
	await import( "swiper/css/bundle" );
	const { Navigation, Pagination } = await import( "swiper/modules" );
	const $slider = $block.find( ".author-posts__slider" );

	if ( !$slider.length ) { return false; }

	const authorSlider = new Swiper( $slider[0], {
		modules: [Navigation, Pagination],
		slidesPerView: 1,
		speed: 1000,
		spaceBetween: 16,
		pagination: {
			el: ".author-posts__pagination",
			type: "bullets",
			clickable: true,
		},
		navigation: {
			nextEl: ".author-posts__next",
			prevEl: ".author-posts__prev",
		},
		breakpoints: {
			1199: {slidesPerView: 4},
			940: {slidesPerView: 3},
			600: {slidesPerView: 2},
		}
	} );

	authorSlider.init();
};
 
themeUtils.loadBlock( authorPosts, "author", ".author-posts" );